import '@fontsource/ibm-plex-sans-arabic/400.css';
import '@fontsource/ibm-plex-sans-arabic/500.css';
import '@fontsource/ibm-plex-sans-arabic/600.css';
import '@fontsource/ibm-plex-sans-arabic/700.css';
import '@fontsource-variable/inter/index.css';
import './styles.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { ApiError } from './api/client.ts';
import { SessionProvider } from './auth/session.tsx';
import { initI18n } from './i18n.ts';
import { desktop } from './platform.ts';
import { router } from './router.tsx';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Refusals (permission, validation, not found) are final; only network trouble is retried.
      retry: (count, error) =>
        count < 2 &&
        (!(error instanceof ApiError) || error.code === 'NETWORK' || error.status >= 500),
      refetchOnWindowFocus: true,
    },
  },
});

await initI18n();

const root = document.getElementById('root');
if (root && desktop && window.location.pathname === '/print-render') {
  // Dob Desktop's hidden print renderer (M7-6): no router, no sign-in session.
  const { PrintRender } = await import('./pages/printing/PrintRender.tsx');
  createRoot(root).render(<PrintRender />);
} else if (root) {
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <SessionProvider>
          <RouterProvider router={router} />
        </SessionProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}
